export enum PaymentMethodType {
    CreditCard,
    PayPal
}